/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRoot2FaRouteImport } from './routes/auth/root-2-fa'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthNewPasswordRouteImport } from './routes/auth/new-password'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as ProtectedSupplierHomeRouteImport } from './routes/_protected/supplier/home'
import { Route as ProtectedSupplierHistoryRouteImport } from './routes/_protected/supplier/history'
import { Route as ProtectedSupplierChangePasswordRouteImport } from './routes/_protected/supplier/change-password'
import { Route as ProtectedRootUsersRouteImport } from './routes/_protected/root/users'
import { Route as ProtectedRootHomeRouteImport } from './routes/_protected/root/home'
import { Route as ProtectedRootCustomerRelationRouteImport } from './routes/_protected/root/customer-relation'
import { Route as ProtectedFactoryHomeRouteImport } from './routes/_protected/factory/home'
import { Route as ProtectedFactoryHistoryRouteImport } from './routes/_protected/factory/history'
import { Route as ProtectedFactoryChangePasswordRouteImport } from './routes/_protected/factory/change-password'

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoot2FaRoute = AuthRoot2FaRouteImport.update({
  id: '/root-2-fa',
  path: '/root-2-fa',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNewPasswordRoute = AuthNewPasswordRouteImport.update({
  id: '/new-password',
  path: '/new-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const ProtectedSupplierHomeRoute = ProtectedSupplierHomeRouteImport.update({
  id: '/supplier/home',
  path: '/supplier/home',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSupplierHistoryRoute =
  ProtectedSupplierHistoryRouteImport.update({
    id: '/supplier/history',
    path: '/supplier/history',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedSupplierChangePasswordRoute =
  ProtectedSupplierChangePasswordRouteImport.update({
    id: '/supplier/change-password',
    path: '/supplier/change-password',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedRootUsersRoute = ProtectedRootUsersRouteImport.update({
  id: '/root/users',
  path: '/root/users',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedRootHomeRoute = ProtectedRootHomeRouteImport.update({
  id: '/root/home',
  path: '/root/home',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedRootCustomerRelationRoute =
  ProtectedRootCustomerRelationRouteImport.update({
    id: '/root/customer-relation',
    path: '/root/customer-relation',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedFactoryHomeRoute = ProtectedFactoryHomeRouteImport.update({
  id: '/factory/home',
  path: '/factory/home',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedFactoryHistoryRoute = ProtectedFactoryHistoryRouteImport.update({
  id: '/factory/history',
  path: '/factory/history',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedFactoryChangePasswordRoute =
  ProtectedFactoryChangePasswordRouteImport.update({
    id: '/factory/change-password',
    path: '/factory/change-password',
    getParentRoute: () => ProtectedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/new-password': typeof AuthNewPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/root-2-fa': typeof AuthRoot2FaRoute
  '/factory/change-password': typeof ProtectedFactoryChangePasswordRoute
  '/factory/history': typeof ProtectedFactoryHistoryRoute
  '/factory/home': typeof ProtectedFactoryHomeRoute
  '/root/customer-relation': typeof ProtectedRootCustomerRelationRoute
  '/root/home': typeof ProtectedRootHomeRoute
  '/root/users': typeof ProtectedRootUsersRoute
  '/supplier/change-password': typeof ProtectedSupplierChangePasswordRoute
  '/supplier/history': typeof ProtectedSupplierHistoryRoute
  '/supplier/home': typeof ProtectedSupplierHomeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/new-password': typeof AuthNewPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/root-2-fa': typeof AuthRoot2FaRoute
  '/factory/change-password': typeof ProtectedFactoryChangePasswordRoute
  '/factory/history': typeof ProtectedFactoryHistoryRoute
  '/factory/home': typeof ProtectedFactoryHomeRoute
  '/root/customer-relation': typeof ProtectedRootCustomerRelationRoute
  '/root/home': typeof ProtectedRootHomeRoute
  '/root/users': typeof ProtectedRootUsersRoute
  '/supplier/change-password': typeof ProtectedSupplierChangePasswordRoute
  '/supplier/history': typeof ProtectedSupplierHistoryRoute
  '/supplier/home': typeof ProtectedSupplierHomeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/new-password': typeof AuthNewPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/root-2-fa': typeof AuthRoot2FaRoute
  '/_protected/factory/change-password': typeof ProtectedFactoryChangePasswordRoute
  '/_protected/factory/history': typeof ProtectedFactoryHistoryRoute
  '/_protected/factory/home': typeof ProtectedFactoryHomeRoute
  '/_protected/root/customer-relation': typeof ProtectedRootCustomerRelationRoute
  '/_protected/root/home': typeof ProtectedRootHomeRoute
  '/_protected/root/users': typeof ProtectedRootUsersRoute
  '/_protected/supplier/change-password': typeof ProtectedSupplierChangePasswordRoute
  '/_protected/supplier/history': typeof ProtectedSupplierHistoryRoute
  '/_protected/supplier/home': typeof ProtectedSupplierHomeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/new-password'
    | '/auth/reset-password'
    | '/auth/root-2-fa'
    | '/factory/change-password'
    | '/factory/history'
    | '/factory/home'
    | '/root/customer-relation'
    | '/root/home'
    | '/root/users'
    | '/supplier/change-password'
    | '/supplier/history'
    | '/supplier/home'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/new-password'
    | '/auth/reset-password'
    | '/auth/root-2-fa'
    | '/factory/change-password'
    | '/factory/history'
    | '/factory/home'
    | '/root/customer-relation'
    | '/root/home'
    | '/root/users'
    | '/supplier/change-password'
    | '/supplier/history'
    | '/supplier/home'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/auth'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/new-password'
    | '/auth/reset-password'
    | '/auth/root-2-fa'
    | '/_protected/factory/change-password'
    | '/_protected/factory/history'
    | '/_protected/factory/home'
    | '/_protected/root/customer-relation'
    | '/_protected/root/home'
    | '/_protected/root/users'
    | '/_protected/supplier/change-password'
    | '/_protected/supplier/history'
    | '/_protected/supplier/home'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/root-2-fa': {
      id: '/auth/root-2-fa'
      path: '/root-2-fa'
      fullPath: '/auth/root-2-fa'
      preLoaderRoute: typeof AuthRoot2FaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/new-password': {
      id: '/auth/new-password'
      path: '/new-password'
      fullPath: '/auth/new-password'
      preLoaderRoute: typeof AuthNewPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_protected/supplier/home': {
      id: '/_protected/supplier/home'
      path: '/supplier/home'
      fullPath: '/supplier/home'
      preLoaderRoute: typeof ProtectedSupplierHomeRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/supplier/history': {
      id: '/_protected/supplier/history'
      path: '/supplier/history'
      fullPath: '/supplier/history'
      preLoaderRoute: typeof ProtectedSupplierHistoryRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/supplier/change-password': {
      id: '/_protected/supplier/change-password'
      path: '/supplier/change-password'
      fullPath: '/supplier/change-password'
      preLoaderRoute: typeof ProtectedSupplierChangePasswordRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/root/users': {
      id: '/_protected/root/users'
      path: '/root/users'
      fullPath: '/root/users'
      preLoaderRoute: typeof ProtectedRootUsersRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/root/home': {
      id: '/_protected/root/home'
      path: '/root/home'
      fullPath: '/root/home'
      preLoaderRoute: typeof ProtectedRootHomeRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/root/customer-relation': {
      id: '/_protected/root/customer-relation'
      path: '/root/customer-relation'
      fullPath: '/root/customer-relation'
      preLoaderRoute: typeof ProtectedRootCustomerRelationRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/factory/home': {
      id: '/_protected/factory/home'
      path: '/factory/home'
      fullPath: '/factory/home'
      preLoaderRoute: typeof ProtectedFactoryHomeRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/factory/history': {
      id: '/_protected/factory/history'
      path: '/factory/history'
      fullPath: '/factory/history'
      preLoaderRoute: typeof ProtectedFactoryHistoryRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/factory/change-password': {
      id: '/_protected/factory/change-password'
      path: '/factory/change-password'
      fullPath: '/factory/change-password'
      preLoaderRoute: typeof ProtectedFactoryChangePasswordRouteImport
      parentRoute: typeof ProtectedRoute
    }
  }
}

interface ProtectedRouteChildren {
  ProtectedFactoryChangePasswordRoute: typeof ProtectedFactoryChangePasswordRoute
  ProtectedFactoryHistoryRoute: typeof ProtectedFactoryHistoryRoute
  ProtectedFactoryHomeRoute: typeof ProtectedFactoryHomeRoute
  ProtectedRootCustomerRelationRoute: typeof ProtectedRootCustomerRelationRoute
  ProtectedRootHomeRoute: typeof ProtectedRootHomeRoute
  ProtectedRootUsersRoute: typeof ProtectedRootUsersRoute
  ProtectedSupplierChangePasswordRoute: typeof ProtectedSupplierChangePasswordRoute
  ProtectedSupplierHistoryRoute: typeof ProtectedSupplierHistoryRoute
  ProtectedSupplierHomeRoute: typeof ProtectedSupplierHomeRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedFactoryChangePasswordRoute: ProtectedFactoryChangePasswordRoute,
  ProtectedFactoryHistoryRoute: ProtectedFactoryHistoryRoute,
  ProtectedFactoryHomeRoute: ProtectedFactoryHomeRoute,
  ProtectedRootCustomerRelationRoute: ProtectedRootCustomerRelationRoute,
  ProtectedRootHomeRoute: ProtectedRootHomeRoute,
  ProtectedRootUsersRoute: ProtectedRootUsersRoute,
  ProtectedSupplierChangePasswordRoute: ProtectedSupplierChangePasswordRoute,
  ProtectedSupplierHistoryRoute: ProtectedSupplierHistoryRoute,
  ProtectedSupplierHomeRoute: ProtectedSupplierHomeRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthNewPasswordRoute: typeof AuthNewPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthRoot2FaRoute: typeof AuthRoot2FaRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthNewPasswordRoute: AuthNewPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthRoot2FaRoute: AuthRoot2FaRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
